/* Aurelle theme — lightweight interactions */
(function () {
  function openDrawer(id) {
    var d = document.getElementById(id);
    var o = document.getElementById('drawer-overlay');
    if (d) d.classList.add('is-open');
    if (o) o.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeAll() {
    document.querySelectorAll('.drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); });
    var o = document.getElementById('drawer-overlay');
    if (o) o.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-drawer-open]');
    if (openBtn) { e.preventDefault(); openDrawer(openBtn.getAttribute('data-drawer-open')); return; }
    if (e.target.closest('[data-drawer-close]') || e.target.id === 'drawer-overlay') { closeAll(); }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* Mobile submenu toggles */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-subtoggle]');
    if (!t) return;
    e.preventDefault();
    var sub = t.parentElement.querySelector('.mobile-nav__sub');
    if (sub) sub.style.display = (sub.style.display === 'block') ? 'none' : 'block';
  });

  /* Cart count refresh after add (basic) */
  window.addEventListener('load', function () {
    document.querySelectorAll('form[action$="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function () {
        setTimeout(function () {
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
            document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
          });
        }, 400);
      });
    });
  });
})();
